import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  Stack
} from '@mui/material';
import { FolderSpecial as ProjectIcon } from '@mui/icons-material';

const slugify = (text) =>
  (text || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);

const hexToRgba = (hex, alpha) => {
  if (!hex || typeof hex !== 'string' || !/^#[0-9A-Fa-f]{6}$/.test(hex)) {
    return `rgba(76, 175, 80, ${alpha})`; // fallback green
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const formatDate = (date) =>
  new Date(date).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric'
  });

const ProjectCard = ({ project }) => {
  const slug = slugify(project.name);
  const href = slug
    ? `/shared/project/${project.shareToken}/${slug}`
    : `/shared/project/${project.shareToken}`;
  const color = project.color || '#4caf50';

  return (
    <Card
      sx={{
        overflow: 'hidden',
        transition: 'box-shadow 0.2s',
        '&:hover': { boxShadow: 4, transform: 'none' }
      }}
    >
      <CardActionArea component={Link} to={href} sx={{ p: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {/* Icon badge */}
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1.5,
              bgcolor: hexToRgba(color, 0.09),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <ProjectIcon sx={{ color, fontSize: 20 }} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="body1" fontWeight={600} noWrap>
              {project.name}
            </Typography>
            {project.description && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }}
              >
                {project.description}
              </Typography>
            )}
          </Box>
          {project.updatedAt && (
            <Typography variant="caption" color="text.disabled" sx={{ flexShrink: 0 }}>
              {formatDate(project.updatedAt)}
            </Typography>
          )}
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export default ProjectCard;
